var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"inline-block",style:(_vm.iconStyle)},[(!_vm.hasLocalSvgIcon)?_c('v-img',{attrs:{"eager":"","src":_vm.externalSource}}):(!_vm.isLoading)?_c('span',{style:(_vm.iconStyle),domProps:{"innerHTML":_vm._s(_vm.iconComponent)}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }